// extracted by mini-css-extract-plugin
export var fullGrid = "_2r-3";
export var pdpPreviewContainer = "_2r-1";
export var previewContainer = "_2r-0";
export var togglePreviewContainer = "_2r-2";